import React from 'react';
import styled from 'styled-components';
import { Button } from '../Button';
import {
  CompareMethod,
  Filter,
  FilterMatchingType,
  FilterValue,
} from 'interfaces/filters';
import { theme } from 'theme/theme';
import { COMPARE_OPTIONS } from 'utils/constants';
import { CloseIcon } from 'assets/icons';
import { ButtonsContainer } from '../ButtonsContainer';
import { formatDateToDisplay } from 'utils/dates';

export const StyledFilterBy = styled.div`
  display: flex;
  border: solid 1px ${theme.colors.borderColorDark};
  border-radius: 8px;
  padding: 12px;
  margin: 12px 0;
  background-color: rgba(234, 230, 255, 0.25);
`;

interface Props {
  appliedFilters: Filter[];
  setFilter: (filterName: string, filterValue: FilterValue) => void;
  clearAllFilters: () => void;
}

export const FilteredBy = ({
  appliedFilters,
  setFilter,
  clearAllFilters,
}: Props) => (
  <StyledFilterBy>
    <ButtonsContainer>
      <div>
        Filtered by:
      </div>
      {appliedFilters
        .map((filter) => {
          switch (filter.matching) {
            case FilterMatchingType.NUMBER_COMPARE:
              return (
                <Button
                  key={filter.name}
                  variant="outlined"
                  size="large"
                  onClick={() => setFilter(filter.name, {
                    compareMethod: CompareMethod.EQ, // Default needs to be set
                  })}
                >
                  <span>
                    {filter.label}
                    {' '}
                    {COMPARE_OPTIONS.find((opt) => opt.value === filter.value.compareMethod)?.name}
                    {' '}
                    {filter.value.value1}
                  </span>
                  <CloseIcon />
                </Button>
              );

            case FilterMatchingType.ARRAY_INCLUDES_PROPERTY:
            case FilterMatchingType.ARRAY_INCLUDES_PROPERTY_DROPDOWN:
            case FilterMatchingType.ARRAY_INCLUDES_CUSTOMERS_DROPDOWN_LAZY:
              return filter.value.map((opt: string) => {
                return (
                  <Button
                    key={opt}
                    variant="outlined"
                    size="large"
                    onClick={() => setFilter(filter.name, filter.value.filter((filterOpt: string) => filterOpt !== opt) )}
                  >
                    <span>
                      {opt}
                    </span>
                    <CloseIcon />
                  </Button>
                );
              });

            case FilterMatchingType.STRING_INCLUDES:
              return (
                <Button
                  key={filter.name}
                  variant="outlined"
                  size="large"
                  onClick={() => setFilter(filter.name, '')}
                >
                  <span>
                    {filter.label}
                    {': '}
                    {filter.value}
                  </span>
                  <CloseIcon />
                </Button>
              );

            case FilterMatchingType.DATE_RANGE:
              return (
                <Button
                  key={filter.name}
                  variant="outlined"
                  size="large"
                  onClick={() => setFilter(filter.name, [])}
                >
                  <span>
                    {filter.label}
                    {': '}
                    {`${formatDateToDisplay(filter.value.at(0))} - ${formatDateToDisplay(filter.value.at(1) || filter.value.at(0))}`}
                  </span>
                  <CloseIcon />
                </Button>
              );

            default:
              return null;
          }
        })}
      <Button
        variant="borderless"
        size="large"
        onClick={clearAllFilters}
        pushRight
      >
        Clear All
      </Button>
    </ButtonsContainer>
  </StyledFilterBy>
);
